(() => {
  if (window.TMGCartCount) return;

  const protectionProductId = 10197153743167;
  const surchargeTitle = 'Residential/Farm/Construction Site Surcharge';

  const getVisibleItemCount = (cart) => {
    if (!Array.isArray(cart?.items)) return Math.max(0, Number(cart?.item_count) || 0);

    return cart.items.reduce((count, item) => {
      const productId = Number(item.product_id ?? item.product?.id);
      const productTitle = item.product_title ?? item.product?.title;
      const shouldExclude = productId === protectionProductId || productTitle === surchargeTitle;

      return shouldExclude ? count : count + (Number(item.quantity) || 0);
    }, 0);
  };

  const render = (cart) => {
    const visibleItemCount = getVisibleItemCount(cart);

    document.querySelectorAll('[data-header-cart-count]').forEach((countElement) => {
      countElement.textContent = '';
      countElement.dataset.headerCartCount = visibleItemCount > 0 ? String(visibleItemCount) : '';
      countElement.classList.toggle('visible', visibleItemCount > 0);
    });

    return visibleItemCount;
  };

  const refresh = () => {
    if (!window.routes?.cart_url) return Promise.resolve(0);

    return fetch(`${window.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' },
    })
      .then((response) => (response.ok ? response.json() : Promise.reject(response)))
      .then(render);
  };

  window.TMGCartCount = {
    getVisibleItemCount,
    render,
    refresh,
  };

  window.addEventListener('cartcount:update', (event) => {
    if (Array.isArray(event.detail?.items)) {
      queueMicrotask(() => render(event.detail));
      return;
    }

    refresh().catch((error) => {
      console.error('Unable to refresh the header cart count', error);
    });
  });
})();
